"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbTextbox = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _shapes = require("../../skybase-core/shapes");

var _keyCodes = require("../../skybase-core/constants/keyCodes");

var _handleValidation = require("../../skybase-core/validation/handle-validation");

var _value = require("../../skybase-core/utils/value");

var _logger = require("../../skybase-core/utils/logger");

var _textbox = require("./textbox");

var _textboxGroup = require("./textbox-group");

var _textboxGroupAddon = require("./textbox-group-addon");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NOOP = function NOOP() {};

var SbTextbox = /*#__PURE__*/function (_Component) {
  _inherits(SbTextbox, _Component);

  var _super = _createSuper(SbTextbox);

  function SbTextbox(props) {
    var _this;

    _classCallCheck(this, SbTextbox);

    _this = _super.call(this, props);
    _this.state = {
      isFocused: false
    };
    _this.willUnmount = false;
    _this.handleOnChange = _this.handleOnChange.bind(_assertThisInitialized(_this));
    _this.handleOnFocus = _this.handleOnFocus.bind(_assertThisInitialized(_this));
    _this.handleKeyUp = _this.handleKeyUp.bind(_assertThisInitialized(_this));
    _this.validate = _this.validate.bind(_assertThisInitialized(_this));
    _this.handleOnBlur = _this.handleOnBlur.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SbTextbox, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.willUnmount = true;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var addon = this.props.addon; // ADDON DEPRECATED MESSAGE - remove it in next major version.

      if (!(0, _value.isNullOrUndefined)(addon)) {
        (0, _logger.deprecate)('SbTextbox property "addon" and "addonPosition" are deprecated and will be removed in next major version. Please use instead "addonLeft" or "addonRight".');
      }
    }
  }, {
    key: "validate",
    value: function validate(value) {
      var _this$props = this.props,
          onValidate = _this$props.onValidate,
          onValidated = _this$props.onValidated;

      if (onValidate) {
        var alerts = (0, _handleValidation.handleValidation)(value, onValidate);
        onValidated(alerts);
      }
    }
  }, {
    key: "handleOnChange",
    value: function handleOnChange(event, values) {
      var props = this.props;
      var onChange = props.onChange,
          type = props.type;

      if (type === 'number') {
        onChange(event, values);
      } else {
        onChange(event);
      }

      this.validate(event.target.value);
    }
  }, {
    key: "handleOnFocus",
    value: function handleOnFocus(event) {
      var _this$props2 = this.props,
          onFocus = _this$props2.onFocus,
          selectOnFocus = _this$props2.selectOnFocus;
      this.setState({
        oldValue: event.target.value,
        isFocused: true
      });

      if (onFocus) {
        onFocus(event);
      }

      if (selectOnFocus) {
        event.target.select();
      }
    }
  }, {
    key: "handleKeyUp",
    value: function handleKeyUp(event) {
      var oldValue = this.state.oldValue;
      var onKeyUp = this.props.onKeyUp;

      switch (event.keyCode) {
        case _keyCodes.esc:
          event.target.value = oldValue;
          this.handleOnChange(event);
          event.target.blur();
          break;

        case _keyCodes.enter:
          event.target.blur();
          break;

        default:
          break;
      }

      onKeyUp(event);
    }
  }, {
    key: "handleOnBlur",
    value: function handleOnBlur(event) {
      var onBlur = this.props.onBlur;
      var oldValue = this.state.oldValue;
      onBlur(event, oldValue);

      if (!this.willUnmount) {
        // This will ensure that we will not try to set state while component is unmounting.
        this.setState({
          isFocused: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;

      var prefix = props.prefix,
          suffix = props.suffix,
          addon = props.addon,
          addonPosition = props.addonPosition,
          hasError = props.hasError,
          outerClassName = props.outerClassName,
          outerStyle = props.outerStyle,
          value = props.value,
          type = props.type,
          selectOnFocus = props.selectOnFocus,
          decimalPlaces = props.decimalPlaces,
          onValidate = props.onValidate,
          onValidated = props.onValidated,
          inputRef = props.inputRef,
          addonLeft = props.addonLeft,
          addonRight = props.addonRight,
          rest = _objectWithoutProperties(props, ["prefix", "suffix", "addon", "addonPosition", "hasError", "outerClassName", "outerStyle", "value", "type", "selectOnFocus", "decimalPlaces", "onValidate", "onValidated", "inputRef", "addonLeft", "addonRight"]);

      var isFocused = this.state.isFocused;

      if (!(0, _value.isNullOrUndefined)(addon) || !(0, _value.isNullOrUndefined)(addonLeft) || !(0, _value.isNullOrUndefined)(addonRight)) {
        return /*#__PURE__*/_react.default.createElement(_textboxGroupAddon.TextboxGroupAddon, _extends({}, rest, {
          inputRef: inputRef,
          type: type,
          decimalPlaces: decimalPlaces,
          addon: addon,
          addonPosition: addonPosition,
          addonLeft: addonLeft,
          addonRight: addonRight,
          prefix: prefix,
          suffix: suffix,
          hasError: hasError,
          value: value,
          onChange: this.handleOnChange,
          onBlur: this.handleOnBlur,
          onFocus: this.handleOnFocus,
          onKeyUp: this.handleKeyUp,
          outerClassName: (0, _classnames.default)(outerClassName, {
            'sb-textbox-group-is-focused': isFocused
          }),
          outerStyle: outerStyle
        }));
      }

      return (0, _value.isNullOrUndefined)(suffix) && (0, _value.isNullOrUndefined)(prefix) ? /*#__PURE__*/_react.default.createElement(_textbox.Textbox, _extends({}, rest, {
        inputRef: inputRef,
        type: type,
        decimalPlaces: decimalPlaces,
        hasError: hasError,
        value: value,
        onChange: this.handleOnChange,
        onBlur: this.handleOnBlur,
        onFocus: this.handleOnFocus,
        onKeyUp: this.handleKeyUp
      })) : /*#__PURE__*/_react.default.createElement(_textboxGroup.TextboxGroup, _extends({}, rest, {
        inputRef: inputRef,
        type: type,
        decimalPlaces: decimalPlaces,
        prefix: prefix,
        suffix: suffix,
        hasError: hasError,
        value: value,
        onChange: this.handleOnChange,
        onBlur: this.handleOnBlur,
        onFocus: this.handleOnFocus,
        onKeyUp: this.handleKeyUp,
        outerClassName: (0, _classnames.default)(outerClassName, {
          'sb-textbox-group-is-focused': isFocused
        }),
        outerStyle: outerStyle
      }));
    }
  }]);

  return SbTextbox;
}(_react.Component);

exports.SbTextbox = SbTextbox;

_defineProperty(SbTextbox, "propTypes", {
  addon: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
  addonPosition: _propTypes.default.string,
  decimalPlaces: _propTypes.default.number,
  editable: _propTypes.default.bool,
  formatter: _propTypes.default.func,
  hasError: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  onKeyUp: _propTypes.default.func,
  onValidated: _propTypes.default.func,
  onValidate: _propTypes.default.func,
  outerClassName: _propTypes.default.string,
  prefix: _propTypes.default.string,
  suffix: _propTypes.default.string,
  selectOnFocus: _propTypes.default.bool,
  type: _propTypes.default.string,
  value: _propTypes.default.node,
  style: _propTypes.default.object,
  // eslint-disable-line
  outerStyle: _propTypes.default.object,
  // eslint-disable-line
  inputRef: _shapes.PropTypeRef,
  addonLeft: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
  addonRight: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string])
});

_defineProperty(SbTextbox, "defaultProps", {
  addon: null,
  decimalPlaces: 0,
  hasError: false,
  style: {},
  outerStyle: {},
  type: 'text',
  editable: true,
  addonPosition: 'right',
  selectOnFocus: false,
  outerClassName: null,
  prefix: null,
  suffix: null,
  value: undefined,
  formatter: NOOP,
  onChange: NOOP,
  onBlur: NOOP,
  onKeyUp: NOOP,
  onValidated: NOOP,
  onValidate: null,
  inputRef: NOOP,
  addonLeft: null,
  addonRight: null
});
//# sourceMappingURL=sb-textbox.js.map